<template>
  <div>
    <div class="gs:grid mb-12" action="">
      <div class="md:col-9 xl:col-10 mb-6 md:mb-0">
        <div class="box box--white box--shadow-lg min-height-500">
          <div class="box-header">
            <h2 class="box-title mb-0 weight-400">Mi auto</h2>
          </div>
          <div class="box-body px-4">
            <div class="gs:grid">
              <div class="sm:col-6 md:col-7 xl:col-4 border-r-grey xl:ml-a">
                <!-- YEAR -->
                <div class="form-group pt-6 lg:py-8">
                  <label class="form-label form-label--big" for=""> Año </label>
                  <v-select
                    :options="years"
                    class="form-input form-input--big form-input--v-select"
                    name="year"
                    :reduce="(year) => year.Clave"
                    id="year_select"
                    label="Nombre"
                    v-model="form.year"
                    @input="changeSelectYears"
                    :loading="loading"
                    placeholder="Selecciona"
                  >
                    <template #spinner="{ loading }">
                      <div
                        v-if="loading"
                        style="border-left-color: #000000"
                        class="vs__spinner"
                      ></div>
                    </template>
                    <span slot="no-options">Sin resultados</span>
                  </v-select>
                </div>
              </div>
              <div class="sm:col-10 md:col-9 xl:col-12 ml-0">
                <div class="pb-6 sm:pt-8 lg:pl-4 lg:pr-11 lg:pb-11">
                  <!-- BRAND -->
                  <div class="form-group">
                    <label class="form-label form-label--big" for="">
                      Marca
                    </label>
                    <v-select
                      placeholder="Seleccionar marca"
                      :reduce="(brand) => brand.Clave"
                      label="Nombre"
                      :options="brands"
                      :loading="loadingBrand"
                      :disabled="form.year == ''"
                      @input="changeSelectBrands"
                      v-model="brand_id"
                      class="form-input form-input--big form-input--v-select"
                      name="brand_id"
                      id="brand_select"
                    >
                      <template #spinner="{ loading }">
                        <div
                          v-if="loading"
                          style="border-left-color: #000000"
                          class="vs__spinner"
                        ></div>
                      </template>
                      <span slot="no-options">Sin resultados</span>
                    </v-select>
                  </div>
                  <!-- MODEL -->
                  <div class="form-group">
                    <label class="form-label form-label--big" for="">
                      Modelo
                    </label>
                    <v-select
                      placeholder="Seleccionar modelo"
                      :reduce="(model) => model.Clave"
                      label="Nombre"
                      :options="models"
                      :disabled="brand_id == ''"
                      :loading="loadingModel"
                      @input="changeSelectModels"
                      v-model="model_id"
                      class="form-input form-input--big form-input--v-select"
                      name="model_id"
                      id="model_selected"
                    >
                      <template #spinner="{ loading }">
                        <div
                          v-if="loading"
                          style="border-left-color: #000000"
                          class="vs__spinner"
                        ></div>
                      </template>
                      <span slot="no-options">Sin resultados</span>
                    </v-select>
                  </div>
                  <!-- VERSION-->
                  <div class="form-group mb-9">
                    <label class="form-label form-label--big" for="">
                      Version
                    </label>
                    <v-select
                      placeholder="Seleccionar versión"
                      :reduce="(version) => version.Clave"
                      label="Nombre"
                      :options="versions"
                      :disabled="model_id == ''"
                      :loading="loadingVersion"
                      @input="bindPrices"
                      v-model="version_id"
                      class="form-input form-input--big form-input--v-select"
                      name="version_id"
                      id="version_selected"
                    >
                      <template #spinner="{ loading }">
                        <div
                          v-if="loading"
                          style="border-left-color: #000000"
                          class="vs__spinner"
                        ></div>
                      </template>
                      <span slot="no-options">Sin resultados</span>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md:col-7 xl:col-6">
        <!-- PRICE -->
        <div class="box box--white box--shadow-lg min-height-500">
          <!-- <div class="box-header box-header--reduced">
						<span class="lg:tx-18 weight-500 tx-green-1">
							<img
								class="mr-2"
								width="18px"
								src="/assets/images/helpers/icon-price-green.svg"
								alt=""
							/>
							Precio de venta
						</span>
					</div> -->
          <div class="box-body pt-5 pb-5">
            <!-- <div
							class="xl:tx-24 weight-300 tx-dark-ad px-4 md:px-7 mb-5 xl:mb-10"
						>
							<span>
								$
							</span>
							<span class="tx-40 lg:tx-56">
								<animated-number
									:value="sale_price"
									:formatValue="formatToPrice"
									:duration="durationAnimatedNumber"
								/>
							</span>
							<span>
								MXN
							</span>
						</div> -->
            <div
              class="lg:tx-18 weight-500 tx-orange-1 px-4 md:px-7 mb-5 lg:mb-8"
            >
              <img
                class="mr-2"
                width="18px"
                src="/assets/images/helpers/icon-price-orange.svg"
                alt=""
              />
              Precio de compra
            </div>
            <hr class="m-0" />
            <div class="pt-5 px-4 md:px-7">
              <div class="xl:tx-24 weight-300 tx-dark-ad mb-9">
                <span> $ </span>
                <span class="tx-40 lg:tx-56">
                  <animated-number
                    :value="form.purchase_price"
                    :formatValue="formatToPrice"
                    :duration="durationAnimatedNumber"
                  />
                </span>
                <span> MXN </span>
              </div>
              <p class="tx-10 lg:tx-12 tx-dark-ad opacity-60 line-h-soft m-0">
                Oferta a reserva de revisión de la unidad
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box box--white box--shadow-lg px-12 py-8 mb-12">
      <div class="box-header justify-content-center">
        <h2 class="box-title mb-0 weight-400">Información de contacto</h2>
      </div>
      <div class="box-body px-4 py-6">
        <div class="gs:grid justify-content-center">
          <div class="sm:col-16 md:col-12">
            <div class="form-grid mb-4">
              <div class="form-group sm:col-8 mb-6">
                <label class="form-label tx-gray-ad" for="full_name">
                  Nombre completo
                </label>
                <input
                  id="full_name"
                  name="full_name"
                  class="form-input"
                  :class="err['full_name'] ? 'border-red' : ''"
                  type="text"
                  v-model="form.full_name"
                />
                <span v-if="err['full_name']" class="tx-10 tx-pink-1">{{
                  err["full_name"][0]
                }}</span>
              </div>

              <div class="form-group sm:col-8 mb-6">
                <label class="form-label tx-gray-ad" for="mail_input">
                  Correo electrónico
                </label>
                <input
                  id="mail_input"
                  name="mail_input"
                  class="form-input"
                  :class="err['email'] ? 'border-red' : ''"
                  type="email"
                  v-model="form.email"
                  
                />
                <span v-if="err['email']" class="tx-10 tx-pink-1">{{
                  err["email"][0]
                }}</span>
              </div>
            </div>

            <div class="form-grid mb-4">
              <div class="form-group sm:col-8 mb-6">
                <label class="form-label tx-gray-ad" for="phone_contact">
                  Whatsapp
                </label>
                <input
                  id="phone_contact"
                  name="phone_contact"
                  class="form-input"
                  :class="err['phone_contact'] ? 'border-red' : ''"
                  type="tel"
                  v-mask="'+52 ##-####-####'"
                  placeholder="##-####-####"
                  v-model="form.phone_contact"
                />
                <span v-if="err['phone_contact']" class="tx-10 tx-pink-1">{{
                  err["phone_contact"][0]
                }}</span>
              </div>
              <div class="form-group sm:col-8 mb-6">
                <label for="states" class="form-label tx-gray-ad">
                  Estado
                </label>
                <v-select
                  :options="states"
                  v-model="form.state"
                  :reduce="(state) => state.name"
                  placeholder="Seleccionar"
                  label="title"
                  class="form-input"
                  name="state"
                  id="state_select"
                  :class="err['state'] ? 'border-red' : ''"
                >
                </v-select>
                <span v-if="err['state']" class="tx-10 tx-pink-1">{{
                  err["state"][0]
                }}</span>
              </div>
            </div>
            <div class="tx-left">
              <h3 class="mb-6 weight-400">Información de tu auto:</h3>
            </div>
            <div class="form-grid mb-4">
              <div class="sm:col-7 md:col-1/3">
                <label class="form-label tx-gray-ad" for="year_input">
                  Año
                </label>
                <input
                  readonly
                  id="year_input"
                  name="year_input"
                  class="form-input"
                  :class="err['year'] ? 'border-red' : ''"
                  type="tel"
                  v-mask="'####'"
                  placeholder="0000"
                  v-model="form.year"
                />
                <span v-if="err['year']" class="tx-10 tx-pink-1">{{
                  err["year"][0]
                }}</span>
              </div>
              <div class="sm:col-16 md:col-1/3">
                <label class="form-label tx-gray-ad" for="brand_input">
                  Marca
                </label>
                <input
                  readonly
                  id="brand_input"
                  name="brand_input"
                  class="form-input"
                  :class="err['brand'] ? 'border-red' : ''"
                  type="text"
                  v-model="form.brand"
                />
                <span v-if="err['brand']" class="tx-10 tx-pink-1">{{
                  err["brand"][0]
                }}</span>
              </div>
              <div class="sm:col-7 md:col-1/3">
                <label class="form-label tx-gray-ad" for="model_input">
                  Modelo
                </label>
                <input
                  readonly
                  id="model_input"
                  name="model_input"
                  class="form-input"
                  :class="err['model'] ? 'border-red' : ''"
                  type="text"
                  v-model="form.model"
                />
                <span v-if="err['model']" class="tx-10 tx-pink-1">{{
                  err["model"][0]
                }}</span>
              </div>
            </div>
            <div class="form-group mb-6">
              <label class="form-label tx-gray-ad" for="comments_input">
                Comentarios adicionales
              </label>
              <textarea
                :class="err['additional_comments'] ? 'border-red' : ''"
                class="form-input resize-none"
                name="comments_input"
                id="comments_input"
                cols="30"
                rows="5"
                v-model="form.additional_comments"
              ></textarea>
              <span v-if="err['additional_comments']" class="tx-10 tx-pink-1">{{
                err["additional_comments"][0]
              }}</span>
            </div>
            <button
              class="btn btn--green-ad w-full lg:tx-16 weight-700 h-9 sm:h-10 xl:h-15"
              type="submit"
              @click="sendForm()"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AnimatedNumber from "animated-number-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);
import { TheMask } from "vue-the-mask";
import Form from "vform";
export default {
  components: {
    // AnimatedNumber,
    TheMask,
  },
  data: () => ({
    form: new Form({
      full_name: "",
      email: "",
      phone_contact: "",
      additional_comments: "",
      brand: "",
      model: "",
      version: "",
      year: "",
      sale_price: 0,
      purchase_price: 0,
    }),
    states: [],
    err: [],
    durationAnimatedNumber: 500,
    year_id: "",
    years: [],
    brands: [],
    brand_id: "",
    models: [],
    model_id: "",
    versions: [],
    version_id: "",
    loading: false,
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
  }),

  mounted() {
    this.getYears();
    this.getStates();
  },
  methods: {
    async getStates() {
      try {
        const data = await axios.get("/client/states/all");
        this.states = data.data;
      } catch (err) {
        console.log("error get states");
      }
    },
    formatToPrice(price) {
      let val = (price / 1).toFixed(0).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    bindPrices() {
      if (this.version_id) {
        this.getPrices();
        const version = this.versions
          .filter((version) => version.Clave == this.version_id)
          .map((version) => version.Nombre)
          .pop();
        this.form.version = version;
      }
      (this.form.sale_price = 0), (this.form.purchase_price = 0);
    },
    async getYears() {
      try {
        this.loading = true;
        const { data } = await axios.post("/api/bluebook/quote-car");
        this.years = data.ObtenerAniosResult.Catalogo;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },
    async getBrands() {
      try {
        this.loadingBrand = true;
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_year: this.form.year,
        });
        this.brands = Array.isArray(data.ObtenerMarcasPorAnioResult.Catalogo)
          ? data.ObtenerMarcasPorAnioResult.Catalogo
          : [data.ObtenerMarcasPorAnioResult.Catalogo];
        this.loadingBrand = false;
      } catch (error) {
        this.loadingBrand = false;
        console.error(error);
      }
    },
    async getModels() {
      try {
        this.loadingModel = true;
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_year: this.form.year,
          key_brand: this.brand_id,
        });
        this.models = Array.isArray(
          data.ObtenerModelosPorAnioMarcaResult.Catalogo
        )
          ? data.ObtenerModelosPorAnioMarcaResult.Catalogo
          : [data.ObtenerModelosPorAnioMarcaResult.Catalogo];
        this.loadingModel = false;
      } catch (error) {
        this.loadingModel = false;
        console.error(error);
      }
    },
    async getVersions() {
      try {
        this.loadingVersion = true;
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_year: this.form.year,
          key_brand: this.brand_id,
          key_model: this.model_id,
        });
        this.versions = Array.isArray(
          data.ObtenerVersionesPorAnioMarcaModeloResult.Catalogo
        )
          ? data.ObtenerVersionesPorAnioMarcaModeloResult.Catalogo
          : [data.ObtenerVersionesPorAnioMarcaModeloResult.Catalogo];
        this.loadingVersion = false;
      } catch (error) {
        this.loadingVersion = false;
        console.error(error);
      }
    },
    async getPrices() {
      try {
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_version: this.version_id,
        });
        (this.form.sale_price = data.ObtenerPrecioVersionPorClaveResult.Venta),
          (this.form.purchase_price =
            data.ObtenerPrecioVersionPorClaveResult.Compra);
        this.form.purchase_price =
          parseInt(this.form.purchase_price) +
          (this.form.purchase_price * 10) / 100;
      } catch (error) {
        console.error(error);
      }
    },
    changeSelectYears() {
      (this.form.sale_price = 0), (this.form.purchase_price = 0);
      this.brands = [];
      this.brand_id = "";
      this.models = [];
      this.model_id = "";
      this.versions = [];
      this.version_id = "";
      if (this.form.year) {
        this.getBrands();
      } else {
        console.log("Ocurrió un error");
      }
    },
    changeSelectBrands() {
      (this.form.sale_price = 0), (this.form.purchase_price = 0);
      this.models = [];
      this.model_id = "";
      this.versions = [];
      this.version_id = "";
      if (this.form.year && this.brand_id) {
        this.getModels();
        const brand = this.brands
          .filter((brand) => brand.Clave == this.brand_id)
          .map((brand) => brand.Nombre)
          .pop();
        this.form.brand = brand;
      } else {
        console.log("Ocurrió un error");
      }
    },
    changeSelectModels() {
      (this.form.sale_price = 0), (this.form.purchase_price = 0);
      this.versions = [];
      this.version_id = "";
      if (this.form.year && this.brand_id && this.model_id) {
        this.getVersions();
        const model = this.models
          .filter((model) => model.Clave == this.model_id)
          .map((model) => model.Nombre)
          .pop();
        this.form.model = model;
      } else {
        console.log("Ocurrió un error");
      }
    },
    async sendForm() {
      let vm = this;
      vm.err = [];

      vm.$swal({
        icon: "info",
        title: "Enviando información...",
        text: "Espere un momento",
      });

      let data = await vm.form
        .post("/api/sell-car")
        .then((response) => {
          vm.$swal({
            icon: "success",
            title: "Correo enviado",
            text: "Gracias",
            confirmButtonText: "Aceptar",
          });
          this.formClear();
        })
        .catch((error) => {
          vm.err = error.response.data.errors;
          console.log(error.response.data);
          vm.$swal({
            icon: "error",
            title: "Error",
            text: vm.err["message"]
              ? vm.err["message"]
              : "Se encontraron algunos errores.",
            confirmButtonText: "Aceptar",
          });
          //   this.formClear();
        });
    },
    formClear() {
      this.form.year = "";
      this.brand_id = "";
      this.model_id = "";
      this.version_id = "";
      this.form.sale_price = 0;
      this.form.purchase_price = 0;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_contact = "";
      this.form.brand = "";
      this.form.model = "";
      this.form.version = "";
      this.form.additional_comments = "";
      this.form.state = "";
    },
  },
};
</script>

<style></style>
